import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'h:mm a';
export const DATE_TIME_FORMAT = 'h:mm a, MMM D';
export const DAY_DATE_TIME_FORMAT = 'h:mm a ddd, MMM D';
export const YEAR_DATE_TIME_FORMAT = 'h:mm a ddd, MMM D, YYYY';
export const YEAR_DATE_TIME_TZ_FORMAT = 'h:mm a ddd, MMM D, YYYY z';
export const YEAR_DATE_TIME_WITH_SECONDS_FORMAT = 'YYYY-MM-DD hh:mm:ss';
export const YEAR_DATE_FORMAT = 'MMM D, YYYY';
export const DATE_MONTH_STRING_YEAR_FORMAT = 'DD MMM YYYY';
export const DATE_MONTH_STRING_YEAR_WITH_TIME_FORMAT = 'DD MMM YYYY, hh:mm';

export function formatDate(date, format = DATE_FORMAT) {
  return moment.utc(date).format(format);
}

export function nowInBetween(start, end) {
  return moment().diff(moment(start)) >= 0 && moment().diff(moment(end)) <= 0;
}
